// extracted by mini-css-extract-plugin
module.exports = {"solar-60w-H":"H_solar-60w-H__GurKc"};